import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { coordinationEndpoints } from '@/modules/coordination/constants';

import { coordinationQueryKeys } from './queryKeys';

export const useCoordinationPreconditionsQuery = (
  jobId: string | undefined,
) => {
  return useQuery({
    queryKey: jobId ? coordinationQueryKeys.preconditions(jobId) : [],
    queryFn: jobId
      ? async () => {
          const { data } = await fetchClient.GET(
            coordinationEndpoints.preconditions,
            {
              params: { path: { jobId } },
            },
          );
          return data;
        }
      : skipToken,
  });
};
